import React, { useState } from 'react';
import '@public/css/custom/star-rating.css';
import starEmpty from '@public/images/star_0.svg';
import starHalf from '@public/images/star_half.png';
import starFilled from '@public/images/star_1.svg';

const StarRating = ({ totalStars = 5, onRate }) => {
  const [rating, setRating] = useState(0); // selected value (0..5, step 0.5)
  const [hoverRating, setHoverRating] = useState(0); // live preview while hovering

  const handleClick = (event, starIndex) => {
    const { offsetX, target } = event.nativeEvent;
    const half = target.clientWidth / 2;
    const newRating = starIndex - (offsetX < half ? 0.5 : 0);
    setRating(newRating);
    onRate?.(newRating);
  };

  const formatRating = (n) => {
    if (!n) return '';
    return Number.isInteger(n) ? String(n) : n.toFixed(1);
  };

  // show hover value if active, else locked-in rating
  const display = hoverRating || rating;

  return (
    <div className='d-inline-flex align-items-center gap-2'>
      <div className='star-rating'>
        {[...Array(totalStars)].map((_, index) => {
          const starIndex = index + 1;
          let starSrc = starEmpty;

          if (starIndex - 0.5 === hoverRating || starIndex - 0.5 === rating) {
            starSrc = starHalf;
          } else if (starIndex <= (hoverRating || rating)) {
            starSrc = starFilled;
          }

          return (
            <img
              key={starIndex}
              src={starSrc}
              alt={`Star ${starIndex}`}
              className='star'
              onMouseMove={(e) => {
                const { offsetX, target } = e.nativeEvent;
                const half = target.clientWidth / 2;
                const hoverVal = starIndex - (offsetX < half ? 0.5 : 0);
                setHoverRating(hoverVal);
              }}
              onMouseLeave={() => setHoverRating(0)}
              onClick={(e) => handleClick(e, starIndex)}
              draggable={false}
            />
          );
        })}
      </div>

      {/* rating label 
      <div className='text-muted small'>
        {display ? `${formatRating(display)}/${totalStars} Rating` : ''}
      </div>*/}
    </div>
  );
};

export default StarRating;
